var map = {
	"./img_1.jpg": 5573,
	"./img_10.jpg": 33859,
	"./img_2.jpg": 54046,
	"./img_3.jpg": 81061,
	"./img_4.jpg": 46988,
	"./img_5.jpg": 52239,
	"./img_6.jpg": 9280,
	"./img_7.jpg": 17516,
	"./img_8.jpg": 38844,
	"./img_9.jpg": 60457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4847;